import { UseQueryOptions } from "@tanstack/react-query";

/**
 * Query options for retrying fetches that may fail due to database replica lag.
 *
 * After a write (e.g. retrying a job), the new record may not be immediately
 * visible on read replicas. These options provide exponential backoff tuned to
 * observed replica lag across pipelines clusters:
 *
 *   p50  ~5-25ms
 *   p99  ~20-28ms
 *   max  ~689ms
 *
 * Backoff schedule (cumulative):
 *   Retry 1:  30ms  ( 30ms total)
 *   Retry 2:  90ms  (120ms total)
 *   Retry 3: 270ms  (390ms total)
 *   Retry 4: 810ms (1200ms total)
 */
export const replicaLagRetryOptions: Pick<UseQueryOptions, "retry" | "retryDelay"> = {
  retry: 4,
  retryDelay: (attempt: number) => Math.min(30 * 3 ** attempt, 1000),
};
